<template>
  <div>
    <v-dialog
      v-model="eventModel"
      width="900"
      persistent
      @input="$emit('close')"
    >
      <v-card-actions class="headline mb-3">
        <div class="headline">
          <span class="text-capitalize">{{ eventDetails.title || "" }} </span>
        </div>
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-card>
        <v-card-text>
          <!-- <v-container> -->
          <v-row>
            <v-col class="col-6">
              <v-card tile elevation="0">
                <v-list class="transparent" dense>
                  <v-list-item>
                    <v-list-item-subtitle class="text-left"
                      >Location</v-list-item-subtitle
                    >
                    <v-list-item-title class="font-weight-black text-left">
                      {{ eventDetails.location || "NA" }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-subtitle class="text-left"
                      >Price</v-list-item-subtitle
                    >
                    <v-list-item-title class="font-weight-black text-left">
                      {{ "AED " + eventDetails.price || "NA" }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-subtitle class="text-left"
                      >Payment Type</v-list-item-subtitle
                    >
                    <v-list-item-title class="font-weight-black text-left">
                      {{
                        eventDetails.payment_type == "S" ? "Single" : "Group"
                      }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-subtitle class="text-left"
                      >Start Date</v-list-item-subtitle
                    >
                    <v-list-item-title class="font-weight-black text-left">
                      <span class="text-capitalize"
                        >{{ eventDetails.start_date || "NA" }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-subtitle class="text-left"
                      >End Date</v-list-item-subtitle
                    >
                    <v-list-item-title class="font-weight-black text-left">
                      <span class="text-capitalize"
                        >{{
                          eventDetails.end_date ? eventDetails.end_date : "NA"
                        }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-subtitle class="text-left"
                      >Duration</v-list-item-subtitle
                    >
                    <v-list-item-title class="font-weight-black text-left">
                      <span class="text-capitalize"
                        >{{ eventDetails.duration || "NA" }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-subtitle class="text-left"
                      >Is shared</v-list-item-subtitle
                    >
                    <v-list-item-title class="font-weight-black text-left">
                      <span class="text-capitalize"
                        >{{
                          eventDetails.shared_with_all_followers == 1
                            ? "Yes"
                            : "No"
                        }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-subtitle class="text-left"
                      >Minimum Players</v-list-item-subtitle
                    >
                    <v-list-item-title class="font-weight-black text-left">
                      <span class="text-capitalize"
                        >{{ eventDetails.minimum_players }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-subtitle class="text-left"
                      >Participant Count</v-list-item-subtitle
                    >
                    <v-list-item-title class="font-weight-black text-left">
                      <span class="text-capitalize"
                        >{{ eventDetails.participant_count }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-subtitle class="text-left"
                      >Status</v-list-item-subtitle
                    >
                    <v-list-item-title class="font-weight-black text-left">
                      <span class="text-capitalize"
                        >{{ eventDetails.status ? eventDetails.status : "NA" }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-subtitle class="text-left"
                      >Created at</v-list-item-subtitle
                    >
                    <v-list-item-title class="font-weight-black text-left">
                      <span class="text-capitalize"
                        >{{
                          eventDetails.created_date
                            ? eventDetails.created_date +
                              " " +
                              (eventDetails.created_time
                                ? eventDetails.created_time
                                : " ")
                            : "NA"
                        }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color=" darken-1"
            class="ma-2 white--text green-color"
            text
            @click="
              () => {
                $emit('close');
                eventModel = false;
              }
            "
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    eventID: { type: Number, default: null },
    type: { type: String, default: "details" },
  },
  data() {
    return {
      eventModel: false,
      eventDetails: {},
      image: null,
      menu: false,
      event: {},
      valid: false,
      page: 1,
      totalPages: 1,
      orderId: null,
    };
  },
  watch: {
    eventID(val) {
      if (val != null) {
        this.getEventDetails();
      }
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  mounted() {},
  computed: {},
  methods: {
    getEventDetails() {
      this.$http
        .get("events/admin/event-details/" + this.eventID)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.eventDetails = response.data.data;
            this.eventModel = true;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },

    closeAll() {
      this.eventModel = false;
      this.valid = false;
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.personal-trainer_ic {
  /* background-image: url("../../../assets/images/nav_icon/personal-trainer-grey.png"); */
  padding: 10px;
  background-size: contain;
}

.credit_table table thead tr th {
  background: #066a8c !important;
  color: #fff !important;
}
</style>
